import { render } from "./LegalAcceptanceGate.vue?vue&type=template&id=1d94a97d&scoped=true"
import script from "./LegalAcceptanceGate.vue?vue&type=script&lang=js"
export * from "./LegalAcceptanceGate.vue?vue&type=script&lang=js"

import "./LegalAcceptanceGate.vue?vue&type=style&index=0&id=1d94a97d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d94a97d"]])

export default __exports__